import {DataServiceBase} from "../DataServiceBase";

let alertCountPromise = null;

export class NotificationsService extends DataServiceBase {
    constructor() {
        super('/Notifications');
    }
    
    getCountAsync() {
        return super.getAsync(null, 'Count');
    }

    getListAsync() {         
        return super.getAsync(null, 'List');
    };

    getAlertCountAsync(options = {}) {
        if (options.forceRefresh === true) {
            alertCountPromise = null;
        }

        if (!alertCountPromise) {
            alertCountPromise = super.getAsync(null, 'AlertCount').catch(error => {
                alertCountPromise = null;
                throw error;
            });
        }

        return alertCountPromise;
    }
}
